module.exports = __webpack_public_path__ + "img/couponBGImg.1ba0d3cc.jpg";